export default __webpack_public_path__ + "static/media/womenwear.efb762f8.jfif";